import {getGuid, NativeId} from '@packages/systems/core/utils/NativeIdUtils';

export function getInstanceKey(rendererNativeIdPath: NativeId[]): string {
  return rendererNativeIdPath.map(getGuid).join(' ');
}
